export default Object.freeze({
  id: 'open-hand', definitionId: 'monk:open-hand', classId: 'monk',
  name: 'Warrior of the Open Hand', selectionLevel: 3,
  aliases: ['warrior-of-the-open-hand', 'open hand'],
  description: 'A Monk who masters techniques to disrupt, push, and topple opponents.',
  features: Object.freeze([{
    id: 'monk:open-hand:technique', name: 'Open Hand Technique', level: 3,
    description: 'After each Flurry of Blows hit, optionally Addle the target, Push it up to 15 feet on a failed Strength save, or Topple it on a failed Dexterity save. No additional Focus is required.',
    presentation: {kind: 'passive'}, contracts: [],
  }, {
    id: 'monk:open-hand:wholeness-of-body', name: 'Wholeness of Body', level: 6,
    description: 'As a Bonus Action, roll your Martial Arts die and regain that many Hit Points plus your Wisdom modifier (minimum 1). You can do so a number of times equal to your Wisdom modifier (minimum once), regaining all uses on a Long Rest.',
    presentation: {kind: 'bonus-action'}, contracts: [],
  }, {
    id: 'monk:open-hand:fleet-step', name: 'Fleet Step', level: 11,
    description: 'When you take a Bonus Action other than Step of the Wind, you can also use Step of the Wind immediately after that Bonus Action.',
    presentation: {kind: 'passive'}, contracts: [],
  }, {
    id: 'monk:open-hand:quivering-palm', name: 'Quivering Palm', level: 17,
    description: 'When you hit a creature with an Unarmed Strike, you can spend 4 Focus Points to start lethal vibrations in it, lasting a number of days equal to your Monk level. End them with an action, or by forgoing one attack of your Attack action: the target makes a Constitution save, taking 10d12 Force damage on a failure or half on a success. Only one creature at a time; you can end them harmlessly at any time.',
    presentation: {kind: 'triggered-decision'}, contracts: [],
  }]),
});
